<template>
	<div class="area-selection">
		<van-popup :value="isShow" position="bottom" :style="{ height: '70%' }" round @click-overlay="closeAction">
			<div class="header">
				<div class="header-title">
					<p>请选择</p>
					<van-icon name="cross" size="18" class="right-close" color="#ccc" @click="closeAction" />
				</div>
				<van-steps direction="vertical" :active="setActive - 1" @click-step="changeStop">
					<template v-for="(item, index) in selectArea.list">
						<van-step :key="index" v-if="item.isDisplay">
							<h3>{{ item.name || "请选择" }}</h3>
						</van-step>
					</template>
				</van-steps>
			</div>
			<div class="layout">
				<p class="layout-title">{{ title }}</p>
				<ul class="layout-ul">
					<li v-for="(item, index) in currentArea" :key="index" @click="select(item.name, item.code, item.postCode)" :class="{ active: currentActive === item.code }">
						<p>{{ item.name }}</p>
						<van-icon color="#07c160" name="success" v-if="currentActive === item.code" />
					</li>
				</ul>
			</div>
		</van-popup>
	</div>
</template>

<script>
import areaList from "@/libs/areaList";
import { getProvinces, getCities, getAreas, getTowns, getAddressDetail } from "@/libs/api";
export default {
	name: "areaSelection",
	props: ["isShow", "selectArea"],
	data() {
		return {
			areaList,
			setActive: 0,
			currentType: 0,
			currentArea: [],
			currentActive: "",
			provinceList: [],
			title: "请选择省份/地区",
		};
	},
	mounted() {
		this.$toast.loading({
			duration: 0,
			mask: true,
			message: "加载中...",
		});
		// 修改
		if (this.$route.query.id) {
			this.setActive = 4;
			this.currentType = 4;
			this.$toast.clear();
		}
		// 新增 // 获取省
		else {
			getProvinces("jsonpCallback").then((res) => {
				this.$toast.clear();
				this.currentArea = res.addressInfos;
			});
		}
	},
	methods: {
		closeAction() {
			this.$emit("closePop", false);
			this.$emit("areaData", this.selectArea);
		},
		// 选择地区
		select(name, adcode, postCode) {
			console.log(postCode);
			this.$toast.loading({
				duration: 0,
				mask: true,
				message: "加载中...",
			});
			this.currentActive = adcode;
			if (this.currentType === 4) {
				this.selectArea.list[3].name = name;
				this.selectArea.list[3].adcode = adcode;
				this.selectArea.list[3].isDisplay = true;
				this.selectArea.postCode = postCode;
				this.$emit("closePop", false);
				this.$emit("areaData", this.selectArea);
				this.$toast.clear();
			} else {
				this.title = "请选择省份/地区";
				if (this.selectArea.list[this.currentType].adcode !== adcode) {
					if (this.currentType === 0) {
						this.title = "请选择城市";
						this.selectArea.list[this.currentType + 1].name = "";
						this.selectArea.list[this.currentType + 1].adcode = "";
						this.selectArea.list[this.currentType + 1].isDisplay = false;
						this.selectArea.list[this.currentType + 2].name = "";
						this.selectArea.list[this.currentType + 2].adcode = "";
						this.selectArea.list[this.currentType + 2].isDisplay = false;
						this.selectArea.list[this.currentType + 3].name = "";
						this.selectArea.list[this.currentType + 3].adcode = "";
						this.selectArea.list[this.currentType + 3].isDisplay = false;
						this.setActive = 0;
					} else if (this.currentType === 1) {
						this.title = "请选择县/区";
						this.selectArea.list[this.currentType + 1].name = "";
						this.selectArea.list[this.currentType + 1].adcode = "";
						this.selectArea.list[this.currentType + 1].isDisplay = false;
						this.selectArea.list[this.currentType + 2].name = "";
						this.selectArea.list[this.currentType + 2].adcode = "";
						this.setActive = 1;
					} else if (this.currentType === 2) {
						this.title = "请选择街道";
						this.selectArea.list[this.currentType + 1].name = "";
						this.selectArea.list[this.currentType + 1].adcode = "";
						this.selectArea.list[this.currentType + 1].isDisplay = false;
						this.setActive = 2;
					}
				}
				this.selectArea.list[this.currentType].name = name;
				this.selectArea.list[this.currentType].adcode = adcode;
				this.selectArea.list[this.currentType].isDisplay = true;
				this.selectArea.postCode = postCode;
				this.currentType++;
				this.setActive++;
				switch (this.currentType) {
					case 1:
						this.currentArea = [];
						this.title = "请选择城市";
						getCities(adcode, "jsonpCallback").then((res) => {
							if (res.returnCode === "0000" || res.code === "0000") {
								this.currentArea = res.addressInfos;
								this.$toast.clear();
							} else {
								this.$toast.clear();
							}
						});
						break;
					case 2:
						this.currentArea = [];
						this.title = "请选择县/区";
						getAreas(adcode, "jsonpCallback").then((res) => {
							if (res.returnCode === "0000" || res.code === "0000") {
								this.currentArea = res.addressInfos;
								this.$toast.clear();
							} else {
								this.$toast.clear();
							}
						});
						break;
					case 3:
						this.currentArea = [];
						this.title = "请选择街道";
						let title = {
							"": "暂不选择",
						};
						getTowns(adcode, "jsonpCallback")
							.then((res) => {
								if (res.returnCode === "0000" || res.code === "0000") {
									this.currentArea = res.addressInfos;
									this.$toast.clear();
								} else {
									this.$toast.clear();
								}
							})
							.then(() => {
								this.currentArea.unshift({
									code: "",
									name: "暂不选择",
								});
								this.$toast.clear();
							});
						break;
					default:
						this.setActive = 4;
						this.$emit("closePop", false);
						this.$emit("areaData", this.selectArea);
						this.$toast.clear();
						break;
				}
			}
			console.log(this.selectArea);
		},
		// 步骤切换
		changeStop(number) {
			this.$toast.loading({
				duration: 0,
				mask: true,
				message: "加载中...",
			});
			this.currentArea = [];
			this.setActive = number + 1;
			// 省
			if (number === 0) {
				this.currentType = 0;
				getProvinces("jsonpCallback").then((res) => {
					if (res.returnCode === "0000" || res.code === "0000") {
						this.currentArea = res.addressInfos;
						this.currentActive = this.selectArea.list[0].adcode;
						this.$toast.clear();
					} else {
						this.$toast.clear();
					}
				});
			}
			// 市
			else if (number === 1) {
				this.currentType = 1;
				let adcode = this.selectArea.list[0].adcode;
				getCities(adcode, "jsonpCallback").then((res) => {
					if (res.returnCode === "0000" || res.code === "0000") {
						this.currentArea = res.addressInfos;
						this.currentActive = this.selectArea.list[1].adcode;
						this.$toast.clear();
					} else {
						this.$toast.clear();
					}
				});
			}
			// 区
			else if (number === 2) {
				this.currentType = 2;
				let adcode = this.selectArea.list[1].adcode;
				getAreas(adcode, "jsonpCallback").then((res) => {
					if (res.returnCode === "0000" || res.code === "0000") {
						this.currentArea = res.addressInfos;
						this.currentActive = this.selectArea.list[2].adcode;
						this.$toast.clear();
					} else {
						this.$toast.clear();
					}
				});
			}
			// 街道
			else if (number === 3) {
				this.currentType = 3;
				let adcode = this.selectArea.list[2].adcode;
				getTowns(adcode, "jsonpCallback")
					.then((res) => {
						if (res.returnCode === "0000" || res.code === "0000") {
							this.currentArea = res.addressInfos;
							this.$toast.clear();
						} else {
							this.$toast.clear();
						}
					})
					.then(() => {
						this.currentArea.unshift({
							code: "",
							name: "暂不选择",
						});
						this.currentActive = this.selectArea.list[3].adcode;
						this.$toast.clear();
					});
			}
		},
		// 获取街道
		onGetAress() {
			if (this.$route.query.id) {
				getTowns(this.selectArea.list[2].adcode, "jsonpCallback").then((item) => {
					if (item.returnCode === "0000" || item.code === "0000") {
						this.currentArea = item.addressInfos;
						this.currentActive = this.selectArea.list[3].adcode;
						this.$toast.clear();
					} else {
						this.$toast.clear();
					}
				});
			}
		},
	},
};
</script>

<style scoped lang="scss">
.area-selection {
	::v-deep.van-popup{
		overflow: hidden;
	}
	.header {
		width: 100%;
		left: 0;
		top: 0;
		position: sticky;
		background: #fff;
		&-title {
			text-align: center;
			p {
				line-height: 40px;
			}
			.right-close {
				position: absolute;
				right: 20px;
				top: 10px;
			}
		}
	}
	.layout {
		padding: 10px;
		overflow-y:auto;
		height: 800px;
		box-sizing: border-box;
		&-title {
			color: #999;
			margin-bottom: 10px;
		}
		&-ul {
			-webkit-overflow-scrolling: touch;
			height: 30%;
			overflow: auto;
			li {
				font-size: 15px;
				margin-bottom: 15px;
				display: flex;
				justify-content: space-between;
				align-items: center;
				&.active {
					color: #07c160;
				}
				.van-icon {
					position: unset;
				}
			}
		}
	}
}
</style>
